import { EditPage, EditPageTextField, EditPagePanel, EditPageCheckbox, EditPageSelect } from './../../../common/EditPage';
import { update, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

const CompaniesEdit = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    const { companyId } = useParams();

    useEffect(() => {
        getOne('/admin/clients/companies/', companyId).then(response => {
            setData(response.data.data);
            setMetadata(response.data.metadata);
        });
    }, [companyId]);

    const handleSave = () => {
        update('/admin/clients/companies/', companyId, { data }).then(response => {
            toast.success('Company updated successfully', {});
            navigate('/clients/companies');
        }).catch(error => {
            toast.error('Error updating company: ' + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate('/clients/companies');
    };

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    };

    return (
        <div>
            <ToastContainer />
            <EditPage handleSave={handleSave} handleCancel={handleCancel} title="Edit Company">
                <EditPagePanel className="col-lg-8">
                    <EditPageTextField
                        label="Name"
                        id="name"
                        onChange={onChange}
                        value={data.name}
                        required={true}
                    />
                    <EditPageSelect
                        label="Franchise"
                        id="franchise_id"
                        onChange={onChange}
                        value={data.franchise_id}
                        options={metadata?.franchises}
                    />
                    <EditPageTextField
                        label="Address"
                        id="address"
                        onChange={onChange}
                        value={data.address}
                    />
                    <EditPageTextField
                        label="City"
                        id="city"
                        onChange={onChange}
                        value={data.city}
                    />
                    <EditPageTextField
                        label="State"
                        id="state"
                        onChange={onChange}
                        value={data.state}
                    />
                    <EditPageTextField
                        label="Zip"
                        id="zip"
                        onChange={onChange}
                        value={data.zip}
                    />
                    <EditPageTextField
                        label="Country"
                        id="country"
                        onChange={onChange}
                        value={data.country}
                    />
                    <EditPageTextField
                        label="Phone"
                        id="phone"
                        onChange={onChange}
                        value={data.phone}
                    />
                    <EditPageTextField
                        label="Email"
                        id="email"
                        onChange={onChange}
                        value={data.email}
                    />
                    <EditPageTextField
                        label="Website"
                        id="website"
                        onChange={onChange}
                        value={data.website}
                    />
                    <EditPageTextField
                        label="Logo"
                        id="logo"
                        onChange={onChange}
                        value={data.logo}
                    />
                    <EditPageTextField
                        label="Description"
                        id="description"
                        onChange={onChange}
                        value={data.description}
                    />
                    <EditPageTextField
                        label="Notes"
                        id="notes"
                        onChange={onChange}
                        value={data.notes}
                    />
                    <EditPageCheckbox
                        label="Status"
                        id="status"
                        onChange={onChange}
                        value={data.status}
                    />
                </EditPagePanel>
            </EditPage>
        </div>
    );
};

export default CompaniesEdit; 